import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";

function stringifyWithoutSpace(object) {
  if (Object.keys(object).length === 0) return;
  return JSON.stringify(object).replace(/\s/g, '');
}

function removeBlankValues(object) {
  return JSON.parse(JSON.stringify(object));
}

function validateStatsInput(stats) {
  if (process.env.NODE_ENV !== 'production') {
    if (!stats) {
      throw new Error('Missing stats argument');
    }

    if (!stats.actionName) {
      throw new Error('Missing actionName in stats argument');
    }

    if (stats.destinationID && stats.contextID) {
      throw new Error('Can\'t include both "contextID" and "destinationID" at the same time');
    }

    if (stats.destinationID && stats.upNextID) {
      throw new Error('Can\'t include both "destinationID" and "upNextID" at the same time');
    }

    if (stats.contextID && stats.upNextID) {
      throw new Error('Can\'t include both "contextID" and "upNextID" at the same time');
    }

    if (stats.experimentVariant && !stats.experimentName) {
      throw new Error("Can't parse experimentVariant without an experimentName");
    }

    if (stats.experimentName && !stats.experimentVariant) {
      throw new Error("Can't parse experimentName without an experimentVariant");
    }
  }
}

function getPersonalisation(stats) {
  var recAlg = stats.recAlg,
      experimentName = stats.experimentName,
      experimentVariant = stats.experimentVariant;
  var experiment = experimentName && experimentVariant && "".concat(experimentName, "::").concat(experimentVariant);
  return removeBlankValues({
    REC: recAlg,
    EXP: experiment
  });
}

function getClientRouted(clientRouted) {
  if (clientRouted) {
    return {
      'bbc-client-routed': clientRouted
    };
  }

  return {};
}

var tvrWebUserStats = function tvrWebUserStats(productName) {
  function getMetadata(stats) {
    var position = stats.position,
        msiGateAction = stats.msiGateAction,
        tvLicenceAction = stats.tvLicenceAction,
        trailerTime = stats.trailerTime,
        autoplayTimerCountdown = stats.autoplayTimerCountdown,
        onwardJourneyPanelLoad = stats.onwardJourneyPanelLoad,
        tlecId = stats.tlecId,
        trackId = stats.trackId,
        playedItemsCount = stats.playedItemsCount,
        loadTime = stats.loadTime,
        errorID = stats.errorID,
        volume = stats.volume;
    return {
      APP: "responsive::".concat(productName),
      BID: tlecId,
      POS: position,
      MGA: msiGateAction,
      TME: trailerTime,
      TLA: tvLicenceAction,
      ATC: autoplayTimerCountdown,
      OJL: onwardJourneyPanelLoad,
      TID: trackId,
      PLQ: playedItemsCount,
      LDT: loadTime,
      ERR: errorID,
      VOL: volume
    };
  }

  return {
    buildCpvAttributes: function buildCpvAttributes(stats) {
      validateStatsInput(stats);
      var _stats$container = stats.container,
          container = _stats$container === void 0 ? '' : _stats$container,
          actionName = stats.actionName,
          actionType = stats.actionType,
          destinationID = stats.destinationID,
          contextID = stats.contextID,
          source = stats.source,
          clientRouted = stats.clientRouted;
      return _objectSpread({
        'bbc-container': container,
        'bbc-content-label': actionName,
        'bbc-event-type': actionType,
        'bbc-metadata': stringifyWithoutSpace(getMetadata(stats)),
        'bbc-result': contextID || destinationID,
        'bbc-source': source,
        'bbc-personalisation': stringifyWithoutSpace(getPersonalisation(stats))
      }, getClientRouted(clientRouted));
    },
    fireEvent: function fireEvent(stats) {
      validateStatsInput(stats);
      var background = stats.background,
          container = stats.container,
          actionName = stats.actionName,
          actionType = stats.actionType,
          destinationID = stats.destinationID,
          contextID = stats.contextID,
          upNextID = stats.upNextID,
          source = stats.source;
      var eventType = background ? 'bbc-user-event' : 'bbc-user-click';
      var mappedDetail = {
        container: container,
        label: actionName,
        type: actionType,
        result: contextID || destinationID || upNextID,
        metadata: getMetadata(stats),
        personalisation: getPersonalisation(stats),
        source: source
      };
      var detail = removeBlankValues(mappedDetail);
      document.dispatchEvent(new CustomEvent(eventType, {
        detail: detail
      }));
    }
  };
};

export default tvrWebUserStats;